import {
  ChangeDetectorRef,
  Component,
  HostListener,
  OnDestroy,
  OnInit
} from '@angular/core';
import {HeaderComponent} from '../../landing/header/header.component';
import {MatButton, MatIconButton} from '@angular/material/button';
import {
  MatFormField,
  MatLabel,
  MatSuffix
} from '@angular/material/form-field';
import {MatIcon} from '@angular/material/icon';
import {MatInput} from '@angular/material/input';
import {MatTooltip} from '@angular/material/tooltip';
import {NgForOf, NgIf, NgStyle} from '@angular/common';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import {Router} from '@angular/router';
import {AuthService} from '../../shared/services/auth.service';
import {GlobalService} from '../../shared/services/global.service';
import {AlertService} from '../../shared/services/alert.service';
import {StorageService} from '../../shared/services/storage.service';
import {MatOption, MatSelect} from '@angular/material/select';
import {MatDatepickerInput} from '@angular/material/datepicker';
import {PcbMappingService} from '../../shared/services/pcb-mapping.service';
import {
  MatAutocomplete,
  MatAutocompleteTrigger
} from '@angular/material/autocomplete';
import {debounceTime, distinctUntilChanged} from 'rxjs';
import {filter} from 'rxjs/operators';

@Component({
  selector: 'vex-register',
  standalone: true,
  imports: [
    HeaderComponent,
    MatButton,
    MatFormField,
    MatIcon,
    MatIconButton,
    MatInput,
    MatLabel,
    MatSuffix,
    MatTooltip,
    NgIf,
    ReactiveFormsModule,
    MatSelect,
    MatOption,
    MatDatepickerInput,
    NgForOf,
    NgStyle,
    MatAutocomplete,
    MatAutocompleteTrigger
  ],
  templateUrl: './register.component.html',
  styleUrl: './register.component.scss'
})
export class RegisterComponent implements OnInit, OnDestroy {
  signInForm: FormGroup = new FormGroup({});
  // otpForm: FormGroup = new FormGroup({});
  inputType: any = 'password';
  visible: any = false;
  submitted: any = false;
  formType: string = 'signIn';
  is_submitting: boolean = false;
  pcbMappings: any;
  programs: any;
  courses: any;
  branches: any;
  schools: any;
  showBranchField = false;
  showOtpField = false;
  pageExtras: {} = {
    buttonType: 'REGISTER'
  };

  images: string[] = [
    'assets/images/slider/slider_1.jpg',
    'assets/images/slider/slider_2.webp',
    'assets/images/slider/slider_3.jpg'
  ];
  currentIndex = 0;
  intervalId: any;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private cd: ChangeDetectorRef,
    private authService: AuthService,
    private globalService: GlobalService,
    private alertService: AlertService,
    private pcbMappingService: PcbMappingService
  ) {
    this.checkLogin();
  }

  ngOnInit(): void {
    this.refresh();
    this.startCarousel();
    this.signInForm
      .get('searchKey')
      ?.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      filter((value) => typeof value === 'string')
    )
      .subscribe((searchValue) => {
        this.filterCourseList(searchValue);
      });
    this.signInForm.get('branchSearchKey')?.valueChanges
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        filter(val => typeof val === 'string')
      )
      .subscribe(searchValue => {
        this.filterBranches(searchValue);
      });
  }

  refresh() {
    this.signInForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', Validators.required],
      contact: ['', Validators.required],
      aadhaar_number: ['', Validators.required],
      dob: ['', Validators.required],
      school: ['', Validators.required],
      program: ['', Validators.required],
      course: ['', Validators.required],
      searchKey: ['', Validators.required],
      branch: [''],
      branchSearchKey: [''],
      pcb_mapping: ['', Validators.required],
      otp: ['', Validators.required],
      decoded_otp: ['', Validators.required]
    });
    // this.otpForm = this.fb.group({
    //   otp: ['', Validators.required]
    // });
    this.getPcbMapping();
  }

  startCarousel() {
    this.intervalId = setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.images.length;
    }, 3000); // Change image every 3 seconds
  }

  ngOnDestroy() {
    clearInterval(this.intervalId);
  }

  checkLogin(): void {
    if (
      StorageService.getItem('accessToken') &&
      StorageService.getItem('self')
    ) {
      this.globalService.setAccessToken(StorageService.getItem('accessToken'));
      this.globalService.setSelf(StorageService.getItem('self'));
      this.router.navigateByUrl('/home');
    } else {
      this.router.navigateByUrl('auth/register');
    }
  }

  getPcbMapping(): void {
    this.programs =
      this.courses =
        this.branches =
          this.schools =
            this.pcbMappings =
              null;
    this.pcbMappings = [];
    this.pcbMappingService.get({status: 'ACTIVE'}).subscribe((data) => {
      if (data && data['data'].length > 0) {
        this.pcbMappings = data['data'];
        /*this.programs = this.pcbMappings.filter(
          (value, index, self) =>
            index ===
            self.findIndex((t) => t.program?.name === value?.program?.name)
        );*/
        this.programs = this.pcbMappings
          .filter((value) => value?.program?.name) // remove null or undefined program.name
          .filter(
            (value, index, self) =>
              index ===
              self.findIndex((t) => t.program?.name === value.program?.name)
          );
      }
    });
  }

  getCourse(): void {
    const programId = this.signInForm?.get('program')?.value;
    this.signInForm.get('searchKey')?.setValue(''); // clear search field

    this.courses = this.branches = null;

    // Initially load all courses for the selected program
    this.courses = this.pcbMappings
      .filter((item) => item.program?.id === programId && item.course?.name)
      .filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.course?.name === item.course?.name)
      );
  }

  filterCourseList(searchValue: string): void {
    const programId = this.signInForm?.get('program')?.value;

    this.courses = this.pcbMappings
      .filter(
        (item) =>
          item.program?.id === programId &&
          item.course?.name?.toLowerCase().includes(searchValue.toLowerCase())
      )
      .filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.course?.name === item.course?.name)
      );
  }

  selectSearchSubject(course: any): void {
    if (course) {
      this.signInForm.patchValue({course: course.course.id});
      // You can also store the selected course elsewhere if needed
      this.getBranch();
    }
  }

  displaySubject(course: any): string {
    return course ? `${course.course.name}` : '';
  }

  getBranch(): void {
    this.branches = null;
    let program = this.signInForm?.value?.program;
    let course = this.signInForm?.value?.course;
    let pcbMapping = this.pcbMappings.filter(
      (value) => value.program?.id == program && value.course?.id == course
    )[0];
    this.signInForm.patchValue({
      pcb_mapping: Number(pcbMapping?.id),
      school: pcbMapping?.school_id
    });
    this.branches = this.pcbMappings
      .filter(
        (value) =>
          value.program?.id == program &&
          value.course?.id == course &&
          value.branch?.name
      ) // Remove null program names
      .filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.branch?.name === value.branch?.name)
      );
    if (this.branches && this.branches.length == 0) {
      this.signInForm.patchValue({branch: null});
      this.showBranchField = false;
    } else {
      this.showBranchField = true;
    }
  }

  filterBranches(searchValue: string): void {
    const selectedCourseId = this.signInForm.get('course')?.value;
    const selectedProgramId = this.signInForm.get('program')?.value;

    this.branches = this.pcbMappings
      .filter(item =>
        item.program?.id === selectedProgramId &&
        item.course?.id === selectedCourseId &&
        item.branch?.name?.toLowerCase().includes(searchValue.toLowerCase())
      )
      .filter((item, index, self) =>
        index === self.findIndex(t => t.branch?.name === item.branch?.name)
      );
  }

  selectBranch(branchItem: any): void {
    this.signInForm.patchValue({
      branch: branchItem.branch.id
    });
    this.getMappingId();
  }

  displayBranch(branch: any): string {
    return branch?.branch?.name || '';
  }

  getMappingId() {
    let pcbMapping = this.pcbMappings.filter(
      (value) =>
        value.school?.id == this.signInForm.value.school &&
        value.program?.id == this.signInForm.value.program &&
        value.course?.id == this.signInForm.value.course &&
        value.branch?.id == this.signInForm.value.branch
    )[0];
    this.signInForm.patchValue({
      pcb_mapping: pcbMapping?.id,
      school: pcbMapping?.school_id
    });
  }

  toggleVisibility(): void {
    if (this.visible) {
      this.inputType = 'password';
      this.visible = false;
      this.cd.markForCheck();
    } else {
      this.inputType = 'text';
      this.visible = true;
      this.cd.markForCheck();
    }
  }

  signIn(): void {
    if (
      !this.signInForm.value &&
      this.isValidDate(this.signInForm.getRawValue().contact)
    ) {
      this.alertService.showErrors('Please fill all the fields');
      return;
    }
    const params: {} = {
      name:
        this.signInForm &&
        this.signInForm.getRawValue() &&
        this.signInForm.getRawValue().name
          ? this.signInForm.getRawValue().name
          : '',
      email:
        this.signInForm &&
        this.signInForm.getRawValue() &&
        this.signInForm.getRawValue().email
          ? this.signInForm.getRawValue().email
          : '',
      contact:
        this.signInForm &&
        this.signInForm.getRawValue() &&
        this.signInForm.getRawValue().contact
          ? this.signInForm.getRawValue().contact
          : '',
      dob:
        this.signInForm &&
        this.signInForm.getRawValue() &&
        this.signInForm.getRawValue().dob
          ? this.signInForm.getRawValue().dob
          : '',
      aadhaar_number:
        this.signInForm &&
        this.signInForm.getRawValue() &&
        this.signInForm.getRawValue().aadhaar_number
          ? this.signInForm.getRawValue().aadhaar_number
          : '',
      school_id:
        this.signInForm &&
        this.signInForm.getRawValue() &&
        this.signInForm.getRawValue().school
          ? this.signInForm.getRawValue().school
          : '',
      program_id:
        this.signInForm &&
        this.signInForm.getRawValue() &&
        this.signInForm.getRawValue().program
          ? this.signInForm.getRawValue().program
          : '',
      course_id:
        this.signInForm &&
        this.signInForm.getRawValue() &&
        this.signInForm.getRawValue().course
          ? this.signInForm.getRawValue().course
          : '',
      branch_id:
        this.signInForm &&
        this.signInForm.getRawValue() &&
        this.signInForm.getRawValue().branch
          ? this.signInForm.getRawValue().branch
          : '',
      pcb_mapping_id:
        this.signInForm &&
        this.signInForm.getRawValue() &&
        this.signInForm.getRawValue().pcb_mapping
          ? this.signInForm.getRawValue().pcb_mapping
          : '',
      otp:
        this.signInForm &&
        this.signInForm.getRawValue() &&
        this.signInForm.getRawValue().otp
          ? this.signInForm.getRawValue().otp
          : '',
      decoded_otp:
        this.signInForm &&
        this.signInForm.getRawValue() &&
        this.signInForm.getRawValue().decoded_otp
          ? this.signInForm.getRawValue().decoded_otp
          : ''
    };
    this.authService.register(params).subscribe(
      (data) => {
        if (data && data.id) {
          this.globalService.setAccessToken(data.token);
          this.globalService.setSelf({
            name: data.name,
            email: data.email,
            contact: data.contact,
            user_id: data.id,
            username: data.username,
            user_type: data.user_type
          });
          this.router.navigateByUrl('home');
          this.signInForm.reset();
        }
      },
      (error) => {
        if (error && error.error && error.error.errorDetails) {
          this.alertService.showErrors(error.error.errorDetails);
        } else if (
          error &&
          error.error &&
          error.error.errors['aadhaar_number'] &&
          error.error.errors['aadhaar_number'][0]
        ) {
          this.alertService.showErrors(error.error.errors['aadhaar_number'][0]);
        } else if (
          error &&
          error.error &&
          error.error.errors['name'] &&
          error.error.errors['name'][0]
        ) {
          this.alertService.showErrors(error.error.errors['name'][0]);
        } else if (
          error &&
          error.error &&
          error.error.errors['email'] &&
          error.error.errors['email'][0]
        ) {
          this.alertService.showErrors(error.error.errors['email'][0]);
        } else if (
          error &&
          error.error &&
          error.error.errors['contact'] &&
          error.error.errors['contact'][0]
        ) {
          this.alertService.showErrors(error.error.errors['contact'][0]);
        } else if (
          error &&
          error.error &&
          error.error.errors['otp'] &&
          error.error.errors['otp'][0]
        ) {
          this.alertService.showErrors(error.error.errors['otp'][0]);
        } else if (
          error &&
          error.error &&
          error.error.errors['decoded_otp'] &&
          error.error.errors['decoded_otp'][0]
        ) {
          this.alertService.showErrors('Please Verify your Contact Number');
        } else if (
          error &&
          error.error &&
          error.error.errors['pcb_mapping_id'] &&
          error.error.errors['pcb_mapping_id'][0]
        ) {
          this.alertService.showErrors(error.error.errors['pcb_mapping_id'][0]);
        } else if (
          error &&
          error.error &&
          error.error.errors['dob'] &&
          error.error.errors['dob'][0]
        ) {
          this.alertService.showErrors(error.error.errors['dob'][0]);
        } else if (
          error &&
          error.error &&
          error.error.errors['school_id'] &&
          error.error.errors['school_id'][0]
        ) {
          this.alertService.showErrors(error.error.errors['school_id'][0]);
        } else if (
          error &&
          error.error &&
          error.error.errors['program_id'] &&
          error.error.errors['program_id'][0]
        ) {
          this.alertService.showErrors(error.error.errors['program_id'][0]);
        } else if (
          error &&
          error.error &&
          error.error.errors['course_id'] &&
          error.error.errors['course_id'][0]
        ) {
          this.alertService.showErrors(error.error.errors['course_id'][0]);
        } else if (
          error &&
          error.error &&
          error.error.errors['branch_id'] &&
          error.error.errors['branch_id'][0]
        ) {
          this.alertService.showErrors(error.error.errors['branch_id'][0]);
        }
      }
    );
  }

  getOtp(): void {
    this.submitted = true;
    this.is_submitting = true;
    if (this.signInForm.getRawValue().contact == '') {
      this.is_submitting = false;
      this.submitted = false;
      this.alertService.showErrors('Contact number is required');
      return;
    }
    if (this.is_submitting) {
      const params: {} = {
        contact:
          this.signInForm &&
          this.signInForm.getRawValue() &&
          this.signInForm.getRawValue().contact
            ? this.signInForm.getRawValue().contact
            : ''
      };
      this.authService.otp(params).subscribe(
        (data) => {
          if (data) {
            this.showOtpField = true;
            this.signInForm.patchValue({
              decoded_otp: data.decoded_otp
            });
          }
        },
        (error) => {
          this.is_submitting = false;
          if (
            error &&
            error.error &&
            error.error.errors['contact'] &&
            error.error.errors['contact'][0]
          ) {
            this.alertService.showErrors(error.error.errors['contact'][0]);
          }
        }
      );
    }
  }

  isValidDate(dateString: string): boolean {
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    if (!regex.test(dateString)) return false;

    const [year, month, day] = dateString.split('-').map(Number);
    const date = new Date(dateString);

    return (
      !isNaN(date.getTime()) &&
      date.getFullYear() === year &&
      date.getMonth() + 1 === month &&
      date.getDate() === day
    );
  }

  goTo(url) {
    this.router.navigateByUrl(url);
  }

  @HostListener('document:contextmenu', ['$event'])
  onRightClick(event: MouseEvent) {
    event.preventDefault();
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // F12, Ctrl+Shift+I/J/C/U
    if (
      event.key === 'F12' ||
      (event.ctrlKey &&
        event.shiftKey &&
        ['I', 'J', 'C'].includes(event.key.toUpperCase())) ||
      (event.ctrlKey && event.key.toLowerCase() === 'u')
    ) {
      event.preventDefault();
    }

    if (event.key === 'F12') {
      event.preventDefault();
    }

    // Optionally block other DevTools shortcuts
    if (
      (event.ctrlKey &&
        event.shiftKey &&
        ['I', 'J', 'C'].includes(event.key.toUpperCase())) ||
      (event.ctrlKey && event.key.toLowerCase() === 'u')
    ) {
      event.preventDefault();
    }
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    // Prevent Ctrl+C (copy)
    if (event.ctrlKey && event.key.toLowerCase() === 'c') {
      event.preventDefault();
    }

    if (event.key === 'F12' || event.keyCode === 123) {
      event.preventDefault();
    }

    // Ctrl+Shift+I / J / C
    if (
      event.ctrlKey &&
      event.shiftKey &&
      ['I', 'J', 'C'].includes(event.key.toUpperCase())
    ) {
      event.preventDefault();
    }

    // Ctrl+U
    if (event.ctrlKey && event.key.toLowerCase() === 'u') {
      event.preventDefault();
    }
  }

  @HostListener('window:keyup', ['$event'])
  onKeyUp(event: KeyboardEvent) {
    if (event.key === 'PrintScreen') {
      document.body.style.filter = 'blur(100px)';
      setTimeout(() => {
        document.body.style.filter = '';
      }, 3000);
    }
  }
}
